import styled from 'styled-components';

const Badge = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 20px;
  width: 20px;
  border-radius: 4px;
  background-color: #c5ffeb;
  border: 1px solid #00d578;
`;

export default Badge;
